import React, { lazy, Suspense, useEffect, useState, useRef } from "react";
import axios from "axios";
import Banner from "../components/Banner/Banner";
import HeaderNavbar from "../components/Navheader/index";
import MediaQuery from "react-responsive";
import jsonData from "./ai-branding.json"; // Import the JSON
import Loader from "../components/Loader/Loader";

import Helmet from "react-helmet";


const Footer = lazy(() => import("./Homefooter/index"));
const ExecutiveTeam = lazy(() =>
  import("../components/ExecutiveTeam/ExecutiveTeam")
);
const Mobileexecutive = lazy(() =>
  import("../components/ExecutiveTeam/MobileExecutive/MobileExecutive")
);
const VoicePresident = lazy(() =>
  import("../components/VoicePresident/VoicePresident")
);
const Mobilevoicepresident = lazy(() =>
  import(
    "../components/VoicePresident/MobileVoicePresident/MobileVoicePresident"
  )
);

export default function Home() {
  const [dpaData, setDPAData] = useState();
  const [loading, setLoading] = useState(true); // Assuming you need a loading state
  const [links, setLinks] = useState(null); // Set initial state as null

  const [showOtherComponents, setShowOtherComponents] = useState(false);

  useEffect(() => {
    const fetchDPAData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LEADERSHIP_JSON}?timestamp=${Date.now()}`);
        setDPAData(response.data);
      } catch (error) {
        console.error("Error fetching DPA data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDPAData();
  }, []);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.offsetHeight;
    const scrollPosition =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    const maxScroll = documentHeight - windowHeight;
    const percentage = (scrollPosition / maxScroll) * 100;

    if (percentage > 0) {
      setShowOtherComponents(true);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (showOtherComponents) {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [showOtherComponents]);

  if (dpaData) {
    const bannerData = dpaData.banner;
    const executiveTeam = dpaData.executiveTeam;
    const executiveVicePresidents = dpaData.ExecutiveVicePresidents;
    return (
      <>
      <Helmet>
        <link rel="canonical" href="https://www.angelai.com/leadership/" />
    </Helmet>
    <>
        <HeaderNavbar bannerData={bannerData} />
        <MediaQuery minWidth={992}>
          {bannerData ? (
            <Banner bannerData={bannerData} fetchpriority="high" />
          ) : null}
         

          <Suspense fallback={<div>Loading...</div>}>
            {executiveTeam ? (
              <ExecutiveTeam
                executiveTeam={executiveTeam}
                fetchpriority="high"
              />
            ) : null}
          </Suspense>
          {showOtherComponents && (
            <>
              <Suspense fallback={<div>Loading...</div>}>
                {executiveVicePresidents ? (
                  <VoicePresident
                    executiveVicePresidents={executiveVicePresidents}
                    fetchpriority="high"
                  />
                ) : null}
              </Suspense>
             
            </>
          )}
        </MediaQuery>

        <MediaQuery maxWidth={991}>
          {bannerData ? (
            <Banner bannerData={bannerData} fetchpriority="high" />
          ) : null}
         

          <Suspense fallback={<div>Loading Executive Team...</div>}>
            {executiveTeam ? (
              <Mobileexecutive
                executiveTeam={executiveTeam}
                fetchpriority="high"
              />
            ) : null}
          </Suspense>
          {showOtherComponents && (
            <>
              <Suspense fallback={<div>Loading...</div>}>
                {executiveVicePresidents ? (
                  <Mobilevoicepresident
                    executiveVicePresidents={executiveVicePresidents}
                    fetchpriority="high"
                  />
                ) : null}
              </Suspense>
             
            </>
          )}
        </MediaQuery>
        <Suspense fallback={<div>Loading...</div>}>
                <Footer fetchpriority="low" links={links.current} />
              </Suspense>
            
        </>
      </>
    );
  } else {
    return null;
  }
}
